export const incentiveConfig = {
     list: {
          tableMapper: [
               {
                    id: "name",
                    name: "Campaign Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "type",
                    name: "Type",
                    isShow: true,
                    align: "center",
                    type: "fillLabel",
                    isNormalTest: true,
               },
               {
                    id: "saleTemplateName",
                    name: "Template",
                    isShow: false,
                    align: "center",
                    type: "text",
                    isNormalTest: true,
               },

               {
                    id: "participation",
                    name: "Participation",
                    isShow: true,
                    align: "center",
                    type: "label",
               },
               {
                    id: "startDate",
                    name: "Start",
                    isShow: true,
                    align: "center",
                    type: "dateTime",
                    isNormalTest: true,
               },
               {
                    id: "endDate",
                    name: "End",
                    isShow: true,
                    align: "center",
                    type: "dateTime",
                    isNormalTest: true,
               },
               {
                    id: "status",
                    name: "Status",
                    isShow: true,
                    align: "center",
                    type: "label",
               },
               {
                    id: "isApproved",
                    name: "Approved",
                    isShow: false,
                    align: "center",
                    type: "label",
               },
               {
                    id: "item1",
                    name: "",
                    isShow: true,
                    align: "left",
                    type: "",
               },
               {
                    id: "item2",
                    name: "",
                    isShow: true,
                    align: "left",
                    type: "",
               },
               {
                    id: "item3",
                    name: "",
                    isShow: true,
                    align: "left",
                    type: "",
               },
          ],
     },

     creation: {
          content: {
               contentRevisionTableMap: [
                    {
                         id: "contentRevision",
                         name: "Revision",
                         isShow: true,
                         align: "left",
                         type: "version",
                    },

                    {
                         id: "updatedBy",
                         name: "Updated By",
                         isShow: true,
                         align: "center",
                         type: "text",
                    },

                    {
                         id: "updatedOn",
                         name: "Updated On",
                         isShow: true,
                         align: "center",
                         type: "text",
                    },

                    {
                         id: "changeReason",
                         name: "Reason",
                         isShow: true,
                         align: "center",
                         type: "text",
                    },
                    {
                         id: "item1",
                         name: "",
                         isShow: true,
                         align: "",
                         type: "",
                    },
                    
               ],
          },
     },
};
